<template>
    <div>
        <navigation></navigation>
        <div class="gd_main w_1000">
            <!--页面位置指示-->
            <div class="gdErji_position">
                <span class="gdErji_position_ico"></span>
                <div class="gdErji_position_text">您现在的位置：<span>资讯详情</span></div>
            </div>

            <div class="gdsanji_box">
                <div class="gdsj_title">{{newsInfo.newsTitle}}</div>
                <div class="gdsj_main">
                    <div v-html="newsInfo.content"></div>

                </div>
            </div>
        </div>
        <footer1></footer1>
    </div>
</template>

<script>
    import {getNews} from '../api/api';
    import  navigation from '../components/Navigation';
    import  footer1 from '../components/Footer1';
    export default {
        components: {
            navigation,
            footer1
        },
        data () {
            return {
                newsInfo: {}
            }
        },
        mounted () {
            getNews({
                id: this.$route.query.id
            }).then((response) => {
                this.newsInfo = response.data.data.newsInfo;
                document.title="资讯详情-"+this.newsInfo.newsTitle
            })
        },
        computed: {},
        methods: {}
    }
</script>